import { render, staticRenderFns } from "./systemset.vue?vue&type=template&id=2a83b185&scoped=true&"
import script from "./systemset.vue?vue&type=script&lang=js&"
export * from "./systemset.vue?vue&type=script&lang=js&"
import style0 from "./systemset.vue?vue&type=style&index=0&id=2a83b185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83b185",
  null
  
)

export default component.exports